module.exports = __webpack_public_path__ + "img/img94.6f2c8d8c.svg";